module.exports = __webpack_public_path__ + "static/media/profile-small.b2c4f80c.jpg";